module.exports = __webpack_public_path__ + "static/year2011-2521b5241291830ec2cc293bff7c5fc9.jpg";